import { useNavigate } from 'react-router';
import { Link } from '#components/atoms/link/Link.tsx';
import { MainLayout } from '#components/patterns/layouts/main/MainLayout.tsx';
import { PageHeader } from '#components/patterns/page-header/PageHeader.tsx';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { IdentityProviderFormWrapper } from '../components/form/IdentityProviderFormWrapper.tsx';
import { useCameFromEndpoint } from '../util/useCameFromEndpoint.ts';
import { useSuspenseIsProvidersLimitReached } from '../util/useSuspenseIsProvidersLimitReached.ts';
import { TooManyOidcProvidersModal } from './TooManyOidcProvidersModal.tsx';

export function AddIdentityProviderPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { isProvidersLimitReached, endpointProvidersLimit } = useSuspenseIsProvidersLimitReached();
  const cameFromEndpoint = useCameFromEndpoint();
  const settingsTarget = `/settings/sso${cameFromEndpoint ? '?tab=endpoint' : ''}`;

  function returnToSettings() {
    void navigate(settingsTarget);
  }

  // Wait until we know what kind of user this is
  if (!user) return null;

  // With every provider slot taken, they can't create any more.
  if (isProvidersLimitReached) {
    return <TooManyOidcProvidersModal onClose={returnToSettings} providersLimit={endpointProvidersLimit} />;
  }

  return (
    <MainLayout
      header={
        <PageHeader
          title={
            <>
              <Link to={settingsTarget} className="a">
                Single sign-on
              </Link>
              {' / '}
              <span>Add provider</span>
            </>
          }
        />
      }
    >
      <IdentityProviderFormWrapper
        onClose={returnToSettings}
        id={null}
        adminIdentityProvider={null}
        endpointIdentityProvider={null}
      />
    </MainLayout>
  );
}
